import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { TFunction } from 'i18next';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useTheme } from '@/modules/common';
import { Themes, ThemesType } from '@/types/theme';

interface SidebarThemes {
  label: string;
  type: ThemesType;
}

const getThemes = (t: TFunction<'common', undefined>): Array<SidebarThemes> => {
  return [
    {
      label: t('themes.useSystem'),
      type: Themes.SYSTEM,
    },
    {
      label: t('themes.light'),
      type: Themes.LIGHT,
    },
    {
      label: t('themes.dark'),
      type: Themes.DARK,
    },
  ];
};

interface ThemeButtonProps extends PropsWithChildren {}

export const ThemeButton: FC<ThemeButtonProps> = ({ children }) => {
  const { t } = useTranslation('common');
  const { theme, setTheme } = useTheme();

  const [openAppearance, setOpenAppearance] = useState(false);
  const sidebarThemes = useMemo(() => getThemes(t), [t]);

  return (
    <Popover open={openAppearance} onOpenChange={setOpenAppearance}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>

      <PopoverContent className="flex w-[185px] flex-col p-2" align="end" side="right">
        {sidebarThemes.map(item => (
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start font-normal"
            onClick={() => setTheme(item.type)}
            key={item.type}
          >
            {item.label}

            {item.type === theme && <Check className="ml-auto h-4 w-4 text-accent-foreground" />}
          </Button>
        ))}
      </PopoverContent>
    </Popover>
  );
};
